// extracted by mini-css-extract-plugin
export var bounce = "ButtonSearch-module--bounce--824d9";
export var button = "ButtonSearch-module--button--875c7";
export var dotMoveLeft = "ButtonSearch-module--dot-move-left--8011f";
export var dotMoveRight = "ButtonSearch-module--dot-move-right--7d47a";
export var gradient = "ButtonSearch-module--gradient--22cfc";
export var separatorWidth = "ButtonSearch-module--separator-width--ec5f5";